export default function registerMouseScrollDownDiv($, apower) {
  //mouse scroll down button in the main page
  $.registerOnce(".mouse-scroll-down > div", function () {
    this.el.$on("click", function () {
      var screen = $(".main").next();

      $("html, body").animate(
        {
          scrollTop: screen.offset().top,
        },
        500,
        "swing"
      );
    });
  });
}
